import Entity from '../entity'
import Share from './Share';
import WxAppUser from './WxAppUser';
import WxUserApp from './WxUserApp';

export default class WxApp extends Entity<number>{
    appId: string  = null;
    originId: string  = null;
    appSecret: string  = null;
    appName: string  = null;
    appType: string  = null;
    tenantId: number  = null;
    mchId: string  = null;
    remark: string  = null;
    shares: Array<Share>;
    wxAppUsers: Array<WxAppUser>;
    wxUserApps: Array<WxUserApp>;
}